import React, {useEffect, useState,memo} from 'react';
import {Head, Loading} from "../../components";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import {useDispatch, useSelector} from "react-redux";
import {period} from "../../actions";
import { useLocation} from "react-router-dom";
import PeriodAutoComplete from "../../components/Period";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import RewardParsianExcel from "./excel/parsian";
import RewardSaderatExcel from "./excel/saderat";
import TotalReward from "./excel/total";
import MarketerQualified from "./excel/qualified";
import {useNavigate} from "react-router";
import queryString from 'query-string';

const PeriodList = ( props ) => {


    const location = useLocation();
    const history = useNavigate();

    const dispatch = useDispatch();
    const  AppState  = useSelector(state => state);

    const [loading, setLoading] = useState(false);
    const [entities, setEntities] = useState([]);

    useEffect(() => {
        if (AppState.period.ready !== 'success') {
            dispatch(period());
        }
    }, [AppState.period.ready]);



    const handleChangeSearchInputWithAutoComplete = (name, value) => {
        _makeQueryStringParams(name, value)
    }


    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        month_id: query.month_id ? parseInt(query.month_id) : '',
        period_id: query.period_id ? parseInt(query.period_id) : '',
    });


    const handleRequest = () => {

        setLoading(true);
        new Api().get('/period/list', {
            page: params.page,
            limit: params.limit,
            month_id: params.month_id,
            period_id: params.period_id,
        }).then((response) => {
            if (typeof response !== "undefined") {
                setEntities(response);
            }
            setLoading(false)
        })
    }

    useEffect(() => {

        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.page,
        params.limit,
        params.month_id,
        params.period_id,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if (n_params.page !== parseInt(query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'limit':
                    if (n_params.limit !== parseInt(query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'month_id':
                    if (n_params.month_id !== query.month_id) {
                        n_params.month_id = query.month_id;
                    }
                    break;
                case 'period_id':
                    if (n_params.period_id !== query.period_id) {
                        n_params.period_id = query.period_id;
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.page,
        query.limit,
        query.period_id,
        query.month_id,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
            case 'limit':
                n_params.limit = value;
                break;
            case 'month_id':
                n_params.month_id = value;
                break;
            case 'period_id':
                n_params.period_id = value;
                break;
        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&limit=${n_params.limit}`;
        url += `&month_id=${n_params.month_id}`;
        url += `&period_id=${n_params.period_id}`;


        history(`/period/${url}`);

    };

    const pageCount = Math.ceil(parseInt(entities?.total) / parseInt(entities?.per_page));


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'دوره ها', 'description': 'خروجی دوره ها' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <PeriodAutoComplete list={AppState.period.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                            <MenuItem  value="500">500</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>شناسه</th>
                        <th>ماه</th>
                        <th>دوره</th>
                        <th>شروع</th>
                        <th>پایان</th>
                        <th>وضعیت</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {entities.data && entities.data.map((entity, index) => {
                        return(
                            <tr key={index}>
                                <td>{entity.id}</td>
                                <td>{entity.month ? entity.month.title : '-'}</td>
                                <td>{entity.title}</td>
                                <td>{moment(entity.from_date, 'YYYY/MM/DD HH:mm').locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td>{moment(entity.to_date, 'YYYY/MM/DD HH:mm').locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td><span className={'status-' + entity.status}>{entity.status === 1 ? 'فعال' : 'اتمام'}</span></td>
                                <td>
                                    {entity.status === 1 && <MarketerQualified period_id={entity.id} />}
                                    {entity.status === 0 ? <React.Fragment>
                                        <TotalReward period_id={entity.id} />
                                        <RewardParsianExcel period_id={entity.id} />
                                        <RewardSaderatExcel period_id={entity.id} />
                                    </React.Fragment> : '-'}

                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>

            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
        </Container>

    );
}


export default memo(PeriodList);
